


































import { Component, Vue, Prop } from 'vue-property-decorator'
import { ValidationProvider } from 'vee-validate'

import { localize } from "vee-validate"

@Component({
  components: {
    ValidationProvider
  },
  name: 'DropdownList'
})
export default class DropdownList extends Vue {

  @Prop({required: false, default: undefined}) vid!: string
  @Prop({required: true, default: ""}) name!: string
  @Prop({required: false, default: null}) label!: string
  @Prop({required: false, default: ""}) rules!: string[] | object[]
  @Prop({required: true, default: null}) value!: string | number

  @Prop({required: false, default: false}) disabled!: boolean

  //@Event() change
  get innerValue(): string | number {
    return this.value
  }

  set innerValue(value: string | number) {
    this.$emit('input', value)
    this.$emit('change', value)
  }

  created(): void {

    // Validation custom messages - localise the names.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const names: any = {}

    names[this.name] = this.label || this.name

    localize({
      en: {
        names
      },
    })
  }
}
